import { useCallback, useEffect, useState } from 'react';
import api from '../api/api';

export default function useSupportFaq(enabled = true) {
  const [items, setItems] = useState([]);
  const [guides, setGuides] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [attempt, setAttempt] = useState(0);
  const retry = useCallback(() => setAttempt(value => value + 1), []);
  useEffect(() => {
    if (!enabled) return undefined;
    let active = true;
    setLoading(true); setError(false);
    async function load() {
      try {
        const { data } = await api.get('/client-portal/support-faq', { skipLoading: true });
        if (!Array.isArray(data.items) || !data.items.length) throw new Error('FAQ unavailable');
        if (active) {
          setItems(data.items);
          setGuides(Array.isArray(data.guides) ? data.guides : []);
        }
      } catch { if (active) setError(true); }
      finally { if (active) setLoading(false); }
    }
    load();
    return () => { active = false; };
  }, [enabled, attempt]);
  return { items, guides, loading, error, retry };
}
